import { UrlObject } from "url";
import * as _ from "lodash";

import { getLocale } from "./helper";

export const tongQuanPage = {
  routeUrl(): UrlObject {
    let pathname = "/overview";
    return {
      pathname
    };
  },
  routeUrlAlias(): UrlObject {
    let pathname = "/overview";
    let locale = getLocale();

    if (!_.isEmpty(locale)) {
      pathname = `/${locale}` + pathname;
    }

    return { pathname };
  }
};
